export default __webpack_public_path__ + "static/media/regions.4f49ac5d.svg";